import { HttpClient } from "@/app/api/HttpClient";
import { API_PREFIX_CAMPAIGNS_PATH } from "@/constants/prefix-path-api";

type CampaignQueryParams = Record<string, any>;

export const fetchCampaignsData = async (params: CampaignQueryParams = {}) => {
    const baseParams: CampaignQueryParams = {
        "fields[0]": "name",
        "pagination[limit]": params["pagination[limit]"] || 100,
        "publicationState": "preview",
        "locale": "all",
        "sort[0]": "createdAt:desc"
    };

    const { "filters[id][$in]": ids, ...restParams } = params;
    let queryParts: string[] = [];
    const finalParams = { ...baseParams, ...restParams };

    Object.keys(finalParams).forEach(key => {
        if (finalParams[key] !== undefined && finalParams[key] !== "undefined") {
            queryParts.push(`${encodeURIComponent(key)}=${encodeURIComponent(finalParams[key])}`);
        }
    });

    if (Array.isArray(ids) && ids.length > 0) {
        ids.forEach(id => queryParts.push(`filters[id][$in]=${id}`));
    }

    const finalUrl = `${API_PREFIX_CAMPAIGNS_PATH}?${queryParts.join('&')}`;
    const res = await HttpClient.get(finalUrl,{skipDomainFilter:true});

    return res.data?.data || res.data || [];
};